import { c as _c } from "react/compiler-runtime";
import type { Fetchable } from '@morpho-org/blue-sdk';
import type { Time } from '@morpho-org/morpho-ts';
import type { Address, Hex } from 'viem';
import { isDefined } from '@morpho-org/morpho-ts';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import ChartHoverCard from '@/components/charts/components/ChartHoverCard';
import { formatTimeseriesData, isSerieEmpty, removeNullYValuesFromSeries } from '@/components/charts/helpers/highcharts';
import { defaultTimeFrame, timeFrameOptions } from '@/config';
import { toHistoryRange } from '@/helpers/timeseries';
import { orpc } from '@/lib/orpc/client';
import { type Mode, toHoverCardSeries } from './toHoverCardSeries';
const STALE_TIME = 60 * 1000;
export interface MarketPositionHistoryHoverCardProps {
  address?: Fetchable<Address>;
  mode?: Mode;
  chainId: number;
  marketId: Fetchable<Hex>;
  assetsUsd: Fetchable<bigint>;
}

/** The user's collateral or loan in USD over the picked timeframe, charted in a hover card. */
const MarketPositionHistoryHoverCard = t0 => {
  const $ = _c(20);
  const {
    address,
    chainId,
    marketId,
    assetsUsd,
    mode: t1
  } = t0;
  const mode = t1 === undefined ? "collateralUsd" : t1;
  const [timeFrame, setTimeFrame] = useState(defaultTimeFrame);
  let t2;
  if ($[0] !== address || $[1] !== chainId || $[2] !== marketId || $[3] !== timeFrame) {
    t2 = orpc.market.positionHistory.queryOptions({
      input: isDefined(address) && isDefined(marketId) ? {
        chainId,
        marketId,
        userAddress: address,
        range: toHistoryRange(timeFrame)
      } : skipToken,
      staleTime: STALE_TIME
    });
    $[0] = address;
    $[1] = chainId;
    $[2] = marketId;
    $[3] = timeFrame;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t2);
  let T0;
  let partial;
  let t3;
  let unpriced;
  if ($[5] !== data || $[6] !== mode) {
    const {
      series,
      unpriced: t4,
      partial: t5
    } = toHoverCardSeries(data, mode);
    unpriced = t4;
    partial = t5;
    const dataFormat = removeNullYValuesFromSeries(formatTimeseriesData(series));
    T0 = ChartHoverCard;
    t3 = isSerieEmpty(dataFormat) ? [] : dataFormat;
    $[5] = data;
    $[6] = mode;
    $[7] = T0;
    $[8] = partial;
    $[9] = t3;
    $[10] = unpriced;
  } else {
    T0 = $[7];
    partial = $[8];
    t3 = $[9];
    unpriced = $[10];
  }
  const t4 = mode === "collateralUsd" ? "Collateral History" : "Loan History";
  const t5 = isError || unpriced;
  let t6;
  if ($[11] !== T0 || $[12] !== assetsUsd || $[13] !== isLoading || $[14] !== partial || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== timeFrame) {
    t6 = <T0 data={t3} timeFrameOptions={timeFrameOptions} title={t4} total={assetsUsd} loading={isLoading} error={t5} partial={partial} timeFrame={timeFrame} setTimeFrame={setTimeFrame} decimals={18} />;
    $[11] = T0;
    $[12] = assetsUsd;
    $[13] = isLoading;
    $[14] = partial;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = timeFrame;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default MarketPositionHistoryHoverCard;